import React from "react";
import { Box, Divider, MenuItem } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import { useFonte } from "../contextos/FonteContext";
import { tamanhosControlesGlobais } from "../estilos/global";

const niveisFonte = [
  { percentual: 80, nome: "Menor" },
  { percentual: 90, nome: "Pequena" },
  { percentual: 100, nome: "Padrão" },
  { percentual: 110, nome: "Média" },
  { percentual: 120, nome: "Grande" },
  { percentual: 130, nome: "Maior" },
];

// Os dois pontos de entrada usam as mesmas opções e preferências existentes.
export function useOpcoesFonte(onSelect) {
  const { percentual, habilitado, aumentarFonte, diminuirFonte, restaurarFonte } = useFonte();

  const selecionarNivel = (novoPercentual) => {
    if (novoPercentual === 100) {
      restaurarFonte();
    } else {
      const quantidadePassos = Math.abs(novoPercentual - percentual) / 10;
      const ajustar = novoPercentual > percentual ? aumentarFonte : diminuirFonte;
      for (let passo = 0; passo < quantidadePassos; passo += 1) ajustar();
    }
    onSelect?.();
  };

  const itens = niveisFonte.map((nivel) => {
    const selecionado = percentual === nivel.percentual;
    return (
      <MenuItem key={nivel.percentual} role="menuitemradio" aria-checked={selecionado}
        selected={selecionado} onClick={() => selecionarNivel(nivel.percentual)}
        sx={{ minHeight: 44, px: 1.25, gap: 1, borderRadius: 1,
          fontSize: tamanhosControlesGlobais.botao,
          "&.Mui-selected": { color: "primary.main", bgcolor: "var(--sear-superficie-azul, #e8f4ff)" },
        }}>
        <Box component="span" sx={{ minWidth: 44, px: .5, py: .5, borderRadius: .75,
          bgcolor: "action.hover", textAlign: "center", fontSize: tamanhosControlesGlobais.rotulo }}>
          {nivel.percentual}%
        </Box>
        <Box component="span" sx={{ flexGrow: 1 }}>{nivel.nome}</Box>
        {selecionado && <CheckRoundedIcon aria-hidden="true" sx={{ fontSize: 18 }} />}
      </MenuItem>
    );
  });

  itens.push(
    <Divider key="divisor" sx={{ my: .75 }} />,
    <MenuItem key="restaurar" onClick={() => selecionarNivel(100)}
      sx={{ minHeight: 44, px: 1.25, gap: 1, borderRadius: 1, color: "primary.main",
        fontSize: tamanhosControlesGlobais.botao, fontWeight: 500, whiteSpace: "normal" }}>
      <RestartAltRoundedIcon aria-hidden="true" sx={{ fontSize: 18, flexShrink: 0 }} />
      Restaurar padrão (100%)
    </MenuItem>,
  );

  return { percentual, habilitado, itens };
}
